import {theme} from "./Tema";

export const VALORENVIOGRATIS = 350000

export const ESTADOSPRODUCTO = [
    {
        nombre: 'Publicado',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Archivada',
        color: theme.palette.secondary.main
    },
]


export const ESTADOSMENSAJE = [
    {
        nombre: 'Enviando...',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Enviado',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Abortado',
        color: theme.palette.secondary.main
    },
]


export const ESTADOSMAYORISTAS = [
    {
        nombre: 'Nuevo',
        color: '#EA3224'
    },
    {
        nombre: 'Seguimiento',
        color: '#232323'
    },
    {
        nombre: 'Archivado',
        color: '#5c5c5c'
    },
]


export const ESTADOSPEDIDOS = [
    {
        nombre: 'Nuevo',
        color: '#0DA0A9'
    },
    {
        nombre: 'Notificado',
        color: '#232323'
    },
    {
        nombre: 'Contactado',
        color: '#232323'
    },
    {
        nombre: 'Agendado',
        color: '#5c5c5c'
    },
    {
        nombre: 'Archivado',
        color: '#5c5c5c'
    },
]

export const LOCALES = [
    {
        nombre: 'Puenes',
        color: '#FFB100'
    },
    {
        nombre: 'Parque 20 de Julio',
        color: '#E30033'
    },
    {
        nombre: 'Carrera 11',
        color: '#5c5c5c'
    }
]


export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Admin',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Suspendido',
        color: theme.palette.info.main
    },
]

export const ESTADOSMESASCONFIG = [
    {
        nombre: 'Activa',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Suspendida',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Mantenimiento',
        color: theme.palette.info.main
    },
]


export const ESTADOSRESERVAS = [
    {
        nombre: 'Reservada',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Completada',
        color: theme.palette.info.main
    },
    {
        nombre: 'Archivada',
        color: theme.palette.info.main
    },
]


export const ESTADOSFILA = [
    {
        nombre: 'Nuevo',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Completado',
        color: theme.palette.info.main
    },
    {
        nombre: 'Archivado',
        color: theme.palette.info.main
    },
]


export const ESTADONOTIFICACIONES = ['Enviada', 'Programada', 'Archivada']